module.exports = __webpack_public_path__ + "img/79.1.9bebbcb0.jpg";